<div class=" dummy" appFocus></div>
<div>
  <h2 class="heading mb-20">Add Project</h2>
  <div class="flex middle-xs center-xs primary-A200 p-50">

    <div class="flex flex-col-xs flex-row-md middle-xs center-xs  fs-14"  >

      <mat-form-field class="w-60 mr-md-30 no-pb top-form-field">
        <input matInput placeholder="Add Project" aria-label="Leader" [matAutocomplete]="auto"
          [formControl]="projectInputField">
        <svg matSuffix svg-fill="currentColor" class="col-primary-300 use-svg" (click)="clear()" symbol="triangle-down"
          w="8"></svg>
        <mat-autocomplete #auto="matAutocomplete" class="single-autocomplete"
          (optionSelected)='optionSelectChange($event.option.value)'>
          <mat-option *ngFor="let project of filterAllActiveInactiveProject" [value]="project.name">
            {{project.name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <app-button class="mt-15 mt-md-0" [disabled]="isDisabledSave" size="small" (click)=saveProject()>Add</app-button>

    </div>
  </div>
